import React, { Component, CSSProperties } from 'react';
import { ContentState, convertFromRaw, EditorState } from 'draft-js';
import Editor from 'draft-js-plugins-editor';
import createLinkifyPlugin from 'draft-js-linkify-plugin';
import './styles/plugin-linkify.css';
import styled from 'styled-components';


const MarkdownDiv = styled.div`
  color: #333;
  font-family: 'Lato', sans-serif;
   word-break: break-word;
  padding-left: 10px;
  font-size: 16px;
  line-height: 24px;

`;

export class MarkdownPreview extends Component<{style?: CSSProperties, description: string}, {editorState: any}> {
  private  editor: any;
  private readonly linkifyPlugin: any;

  constructor(props: any) {
    super(props);
    this.state = {
      editorState: this.props.description !== undefined
        ? this.props.description.substring(0, 1) === '{'
          ? EditorState.createWithContent(
            convertFromRaw(JSON.parse(this.props.description))
          )
          : EditorState.createWithContent(
            ContentState.createFromText(this.props.description)
          )
        : EditorState.createEmpty(),
    };
    this.linkifyPlugin = createLinkifyPlugin({
      // component: (props2: any) => (
      //   <Test href={props2.href} test={this.state.editorMode === MuEditorMode.Edit ? 'edit' :
      //   'preview'}/>
      // ),
      target: '_blank',
      rel: 'noreferrer noopener',
    });
  }

  onChange = (editorState: any) => {
    this.setState({
      editorState,
    });
  };

  focus = () => {
    this.editor.focus();
  };

  render() {
    const plugins = [this.linkifyPlugin];

    return (
      <MarkdownDiv style={this.props.style}  onClick={this.focus}>
        <Editor
          editorState={this.state.editorState}
          readOnly={true}

          onChange={this.onChange}
          plugins={plugins}
          ref={(element) => { this.editor = element; }}
        />
      </MarkdownDiv>
    );
  }
}